import { render, staticRenderFns } from "./AmountReceived.vue?vue&type=template&id=88981f28&scoped=true&"
import script from "./AmountReceived.vue?vue&type=script&lang=js&"
export * from "./AmountReceived.vue?vue&type=script&lang=js&"
import style0 from "./AmountReceived.vue?vue&type=style&index=0&id=88981f28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88981f28",
  null
  
)

export default component.exports